import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route} from "react-router-dom";
// HELPERS
import { isMobile } from './_helpers';
// ROUTES
import routes from './_routes';

import "./styles.scss";

class App extends Component { 
    constructor(props) {
        super(props);   
        this.state = {}    
    }
    render () {
        return (
            <main>
                <Router>
                    <Fragment>
                        {routes.map((route, i) => 
                            <Route key={i} routes= {routes} exact={route.exact} path={route.path} component={route.component} />
                            
                        )}
                    </Fragment>
                </Router>
            </main>
        );
    }
}

export default App;